// extracted by mini-css-extract-plugin
export default {"title":"BookCard_title__BrqUZ","authors":"BookCard_authors__2MvsH","edition":"BookCard_edition__+Bt2M","alertMessage":"BookCard_alertMessage__noCa8"};